/**
 * Class description
 *
 * Created: 2019-08-29
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ImmortalFruitsGameModuleConfig} from "../../ImmortalFruitsGameModuleConfig";

export class NormalWin implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private _hasWin: boolean;
    private _lastNormalWinConfig: IWinRatioConfig;

    /**
     * @constructs
     * @param lastNormalWinConfig
     * @param stagger
     * @param abortStagger
     */
    constructor(lastNormalWinConfig: IWinRatioConfig, stagger?: number, abortStagger?: number) {
        this._lastNormalWinConfig = lastNormalWinConfig;
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: ParsedGameData): void {
        this._hasWin = data.singleWin > 0 && !data.isBigWin;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedGameData): Timeline | null {
        if (!this._hasWin) {
            return null;
        }
         const countStart: TimelineLite = ImmortalFruitsGameModuleConfig.countUpView.getWinStepAnimation(0, data.singleWin, data.currentWinRatioConfig!.duration);

        const tl: TimelineLite = new TimelineLite();
        tl.add(countStart);

        return tl;
    }
}